import { ImpressionSentEvent } from 'common/event-handling/events';
import eventBus from 'common/event-handling/event-bus.model';
import { FrameLifecycleService } from 'common/services/frame-lifecycle.service';
import { AnalyticsStore } from 'common/stores';

export class FrameLifecycleHandler {
  constructor() {
    this.handle();
  }

  handle() {
    const frameLifecycleService = new FrameLifecycleService((event, fields) =>
      AnalyticsStore.instance?.sendSupplyMonitoringEvent(event, fields)
    );
    frameLifecycleService.listen();

    eventBus.subscribe(ImpressionSentEvent, () => {
      frameLifecycleService.destroy();
    });
  }
}
